import typeStyleMap from 'lib/graph-vis/typeStyleMap';
import { ReactComponent as SvgImage } from '../../../public/images/svg/product.svg';
export const ProductIcon = (props) => (
  <SvgImage
    height={props.height || 24}
    style={{ fill: typeStyleMap.productNode.color }}
    {...props}
  />
);

export const ProductTagIcon = (props) => (
  <span role="img" aria-label="product tag" className="anticon anticon-product-tag">
    <SvgImage style={{ margin: '2px 0 -2px 0' }} height={15} fill={'antiquewhite'} {...props} />
  </span>
);

export default ProductIcon;
